import React, { useState, useEffect } from 'react';
import './midcontent.scss';
import { Link, useLocation } from 'react-router-dom';
import Loader from '../Loader/Loader';
import { HeartFill } from 'react-bootstrap-icons';
import LoginModal from '../Mainpage/LoginModal';
import CartModal from "../Mainpage/CartModal";
import Swal from 'sweetalert2';
import Cookies from 'universal-cookie';
import useFetchWishlist from '../Admin/useFetchWishlist';

const cookies = new Cookies();

const AlsoLike = () => {
  const location = useLocation();
  const isRootPath = location.pathname === '/';
  const [showCart, setShowCart] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [load, setLoad] = useState(true);
  const [err, setErr] = useState(null);

  const { wishlistElements, fetchWishlist } = useFetchWishlist();

  const handleShowLogin = () => setLoginShow(true);
  const handleClose = () => {
    setLoginShow(false);
    setShowCart(false);
  };
  const handleShowCart = () => setShowCart(true);

  useEffect(() => {
    const fetchProducts = async () => {
      setLoad(true);
      try {
        const response = await fetch(`https://backend.indianjewelryish.com/api/like-products`);
        if (!response.ok) throw new Error('Failed to fetch products');
        const data = await response.json();
        setProducts(data?.liked_products || []);
      } catch (error) {
        setErr(error.message);
      } finally {
        setLoad(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [products]);

  const truncateProductName = (name, wordLimit = 7) => {
    const words = name.trim().split(' ');
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(' ') + '...'
      : name;
  };

  const addtocart = async (variant_id, e, product_code) => {
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("user_id") || "";
    const common_id = localStorage.getItem("common_id") || "";

    if (variant_id != null) {
      try {
        const response = await fetch(`https://backend.indianjewelryish.com/api/cart/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            common_id,
            user_id: parseInt(user_id),
            product_code,
            quantity: 1,
            variant_id,
          }),
        });

        if (!response.ok) throw new Error("Network response was not ok");

        const data = await response.json();

        if (data.full) {
          alert("Quantity reached");
        }

        handleShowCart();

        if (data.cart.common_id) {
          localStorage.setItem("common_id", data.cart.common_id);
        }
      } catch (error) {
        if (token || user_id) {
          console.error("Error adding to cart:", error);
        } else {
          localStorage.clear();
          cookies.remove("user_id");
          handleShowLogin();
        }
      }
    } else {
      Swal.fire({
        icon: "warning",
        confirmButtonColor: "#b63f23",
        title: "Select Variant!",
      });
    }
  };

  const wishlistAdd = async (product_code) => {
    const token = localStorage.getItem('token');
    const user_id = localStorage.getItem('user_id') || '';

    try {
      const response = await fetch(`https://backend.indianjewelryish.com/api/add-whishlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id: parseInt(user_id), product_code }),
      });

      if (!response.ok) throw new Error('Network response was not ok');

      const data = await response.json();
      const wishlistElement = document.querySelector('.' + product_code);

      if (data.success) {
        wishlistElement.style.color = 'red';
      } else if (data.remove) {
        wishlistElement.style.color = '#11111199';
      }

      fetchWishlist(); // Refresh wishlist
    } catch (error) {
      if (token || user_id) {
        Swal.fire({
          icon: 'warning',
          confirmButtonColor: '#b63f23',
          title: 'There seems to be an issue adding the item to the wishlist.',
        });
      } else {
        localStorage.clear();
        cookies.remove('user_id');
        handleShowLogin();
      }
    }
  };

  if (load) return <Loader />;
  if (err) return <div className="error">{err}</div>;
  return (
    <>
      <section id='midcontent'>
        {products.map((product) => (
          <div key={product.id} className="card">
            {product?.product_discount && (
              <span className='sale-banner'>
                Sale
              </span>
            )}
            <button
              style={wishlistElements.includes(product.product_code) ? { color: 'red' } : { color: '#11111199' }}
              onClick={() => wishlistAdd(product.product_code)}
              id='wishlistoutside'
              className={product.product_code}
            >
              <HeartFill size={20} />
            </button>

            <Link to={`/productshow/${product.product_code}`}>
              <div className='image-container'>
                <img
                  src={`https://backend.indianjewelryish.com/${product.product_image_1}`}
                  alt={product.product_name}
                />
              </div>
              <h3>{product.product_name}</h3>
              <p className="price">
                ${(product?.variant?.price * (1 - product.product_discount / 100)).toFixed(2)}
                {product?.product_discount && (
                  <span className="price-cut-home">${product?.variant?.price}</span>
                )}
              </p>
              <div className="d-flex justify-content-center p-0 m-0">
                {Array.from({ length: 5 }).map((_, index) => (
                  <span style={{ fontSize: "14px" }} className='rating-star' key={index}>
                    {product.top_review && index < product.top_review.rating ? '★' : '☆'}
                  </span>
                ))}
              </div>
            </Link>

            <div className="d-flex align-items-center justify-content-center">
              {product?.single_product == 1 ? (
                <button
                  className='loginsignupbutton'
                  onClick={(e) => addtocart(product?.variant?.id, e, product?.product_code)}
                  style={{ width: "90%", height: "47px" }}
                >
                  Add to Cart
                </button>
              ) : (
                <Link to={`/productshow/${product.product_code}`} style={{ width: "100%" }}>
                  <button className='loginsignupbutton' style={{ width: "90%", height: "47px" }}>
                    Add Variant
                  </button>
                </Link>
              )}
            </div>

            {product?.variant?.quantity === 0 && product?.single_product > 0 ? (
              <p className="discount mt-2">Out of stock!</p>
            ) : (
              product?.variant?.quantity < 15 && product?.single_product > 0 && (
                <p className="discount mt-2">Only {product?.variant?.quantity} left!</p>
              )
            )}
          </div>
        ))}
      </section>

      <LoginModal show={loginShow} onClose={handleClose} />
      <CartModal show={showCart} onClose={handleClose} />
    </>
  );
};

export default AlsoLike;
